export default __webpack_public_path__ + "static/media/copyleft.8b772b4e.svg";